import { createFileRoute } from '@tanstack/react-router';

import { PaymentAccountsPage } from '@/features/owner/PaymentAccountsPage';

export const Route = createFileRoute('/_authed/owner/payment-accounts')({
  component: PaymentAccountsPage,
});
